
import {userApi} from './user'


console.log('🔗 LOADING: businesstrustchainsget.js');


export const businessTrustchainApi = userApi.injectEndpoints({
  endpoints: (builder) => ({
    getBusinessTrustchain: builder.query({      
      query: (businessId) => {
        console.log('🔗 EXECUTING: getBusinessTrustchain query');
        return `/business/${businessId}/trust-chain`;
      },
    }),
    

  }),
  overrideExisting: false,
})

export const { useGetBusinessTrustchainQuery, usePrefetch } = businessTrustchainApi